class DevStorage {
  constructor(storage) {
    this.storage = storage;
    this.data = {};
  }

  setValue(key, value) {
    this.data[key] = value;
    this.storage.setItem(key, JSON.stringify(value));
  }

  getValue(key) {
    if (!this.data[key]) {
      this.data[key] = JSON.parse(this.storage.getItem(key));
    }
    return this.data[key];
  }

  set showDevTools(value) {
    this.setValue('showDevTools', value);
  }

  get showDevTools() {
    return this.getValue('showDevTools');
  }

  set user(value) {
    this.setValue('user', value);
  }

  get user() {
    return this.getValue('user');
  }

  set userDefinitionRaw(value) {
    this.setValue('userDefinitionRaw', value);
  }

  get userDefinitionRaw() {
    return this.getValue('userDefinitionRaw');
  }
}

export default new DevStorage(sessionStorage);

export const devStoragePersistent = new DevStorage(localStorage);
